import { useMemo } from 'react';
import { Badge } from 'reactstrap';
import { useTexts } from './hooks/useTexts';

export function BadgeStatus({ active }: Readonly<{ active: boolean }>) {
  const status = active ? 'active' : 'inactive';

  const texts = useTexts().table.content.badgeStatuses;

  const colors = useMemo(() => {
    return {
      active: '#CEF0DA',
      inactive: '#DDEFFF',
    };
  }, []);

  const statusText = useMemo(() => {
    return {
      active: texts.active,
      inactive: texts.inactive,
    };
  }, [texts]);

  return (
    <Badge
      className="status-badge fs-16 fw-400 py-2 px-4 text-dark ml-3"
      style={{ backgroundColor: colors[status] }}
      pill
    >
      {statusText[status]}
    </Badge>
  );
}
